import {
  List,
  Datagrid,
  TextField,
  DateField,
  ImageField as RaImageField,
  ReferenceField,
  Edit,
  SimpleForm,
  TextInput,
  ImageInput,
  Create,
  EditButton
} from "react-admin";
import MyRichTextInput from "./MyRichTextInput";

export const NewsList = () => (
  <List>
    <Datagrid>
      <TextField source="title" />
      <RaImageField source="image" />
      <ReferenceField label="Author" source="user_id" reference="users">
        <TextField source="username" />
      </ReferenceField>
      <DateField source="created_at" />
      <EditButton />
    </Datagrid>
  </List>
);

export const NewsEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="title" />
      <MyRichTextInput source="content" label="Content"  />
      <ImageInput source="image" accept="image/*">
        <RaImageField source="src" />
      </ImageInput>
    </SimpleForm>
  </Edit>
);

export const NewsCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="title" />
      <MyRichTextInput source="content" label="Content" />
      <ImageInput source="image" accept="image/*">
        <RaImageField source="src" />
      </ImageInput>
    </SimpleForm>
  </Create>
);
